import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Button from "../../components/Buttons/Button";
import Icon from "../../components/Icon/Icon";
// import SideBarLinks from "../../constants/SideBarLinksAdmin.json";
import { useTranslation } from "react-i18next";
import { fill } from "lodash";
import { useSelector } from "react-redux";
import { index, timeout } from "d3";
import { handleLogOut } from "../../util/Utility";
import FundMeButton from "../Admin/pages/Donate/components/FundMeButton";
import { fontSize } from "styled-system";
import dropdownDown from "../../assets/images/chevron-down.svg";

const styles = {
  dropdownContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  dropdownButton: {
    background: "inherit",
    border: "none",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#D0004B",
    paddingLeft: "10px",
    textAlign: "left",
  },
  arrow: (isOpen) => ({
    marginLeft: "10px",
    transform: isOpen ? "rotate(0deg)" : "rotate(180deg)",
    transition: "transform 0.3s ease",
  }),
  dropdownMenu: {
    left: "0",
    background: "inherit",
    display: "flex",
    flexDirection: "column",
    paddingLeft: "25px",
    fontSize: "14px",
  },
  dropdownItem: {
    textAlign: "left",
    cursor: "pointer",
    textDecoration: "none",
    color: "black",
  },
  activeItem: {
    background: "#d0004b",
    textAlign: "left",
    cursor: "pointer",
    textDecoration: "none",
    color: "white",
    borderRadius: "15px",
  },
  dropdownItemHover: {
    backgroundColor: "#f5f5f5",
  },
  bulkUpload: {
    color: "black",
  },
};

const getClassName = (item,location)=>{
  if(item.label === "mosque_view"){
    if(location.pathname.includes(item?.link) || location.pathname.includes("/viewer_access"))
      return "activeClass"
    else
      return null
  }else{
    if(location.pathname.includes(item?.link))
      return "activeClass"
    else
      return null
  }
}

const LeftSidebar = ({ open, setOpen }) => {
  const location = useLocation();
  const { t } = useTranslation();

  const [show, setshow] = useState(false);
  const [links, setLinks] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownCollapseOpen, setDropdownCollapseOpen] = useState(false);

  const pages = useSelector((state) => state?.appReducer?.pages);
  const userType = useSelector((state) => state?.appReducer?.userType);
  const activeEntity = useSelector((state) => state.adminReducer.activeEntity);

  const handleClick = (e) => {
    e.preventDefault();
    setOpen(!open);
  };

  useEffect(() => {
    if (pages?.length > 0) {
      let appLinks = pages?.filter((item) => item?.display === true);
      setLinks(appLinks);
    }
  }, [pages]);

  return (
    <div className={open ? "whiteBg" : "blackBg"}>
      <div className={open ? "wLogo" : "bLogo"} style={{ paddingLeft: "0px", paddingRight: "0px"}}>
        <img
          style={{
            height: open ? "85px" : "40px",
            width: open ? "100%" : "auto",
            paddingLeft: open ? "0px" : "8px",
            marginLeft: open ? "" : "20px",
            objectFit: open ? "" : "cover",
          }}
          src="/assets/mosqapp-logo-new.svg"
          alt="Logo"
        />
      </div>
      <div className={open ? "wScroll" : "bScroll"}>
        {open ? (
          <>
            {links &&
              links.map((item, i) => (
                <div
                  className="li-content li-margin"
                  key={item?.title}
                >
                  {item?.label === "add_member" ? (
                    // If name is "Add Member", display dropdown
                    <div style={styles.dropdownContainer}>
                      <button
                        onClick={() => {
                          // active(i);
                          setDropdownOpen(!dropdownOpen);
                        }}
                        style={{
                          ...styles.dropdownButton,
                          backgroundColor: "inherit",
                        }}
                      >
                        <Icon
                          iconName={item.icon}
                          width="30px"
                          height="30px"
                          color={item.active ? "#fff" : "#D0004B"}
                        />
                        <h5>{t(item.title)}</h5>
                        {/* <span style={styles.arrow(dropdownOpen)}>⌃</span> */}
                        <img src={dropdownDown} alt="dropdown" style={styles.arrow(dropdownOpen)} />
                      </button>

                      {dropdownOpen && (
                        <div style={styles.dropdownMenu}>
                          {item?.canAddSingleMember && (
                            <NavLink
                              to={`${"/user" + item.link}`}
                              style={({ isActive }) =>
                                isActive &&
                                !location?.pathname?.includes("/bulk-upload")
                                  ? { ...styles.activeItem }
                                  : { ...styles.dropdownItem }
                              }
                            >
                              {t("Add Single Member")}
                            </NavLink>
                          )}
                          {item?.canBulkUploadData && (
                            <NavLink
                              to={`/user/add-members/bulk-upload`}
                              style={({ isActive }) =>
                                isActive &&
                                location?.pathname?.includes("/bulk-upload")
                                  ? { ...styles.activeItem }
                                  : { ...styles.dropdownItem }
                              }
                            >
                              {t("Bulk Upload")}
                            </NavLink>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      {" "}
                      {console.log(' location.pathname.includes(item?.link)',item?.link, location.pathname.includes(item?.link))}
                      <NavLink
                        to={`${"/user" + item.link}`}
                        className={
                          getClassName(item, location)
                        }
                      >
                        {item.label === "mosque_view"?<Icon
                          iconName={
                            (location.pathname.includes(item?.link) || location.pathname.includes("/viewer_access"))
                              ? item?.icon + "Light"
                              : item?.icon
                          }
                          width="30px"
                          height="30px"
                          color={
                            (location.pathname.includes(item?.link) || location.pathname.includes("/viewer_access"))
                              ? "#fff"
                              : "#D0004B"
                          }
                        ></Icon>:<Icon
                          iconName={
                            location.pathname.includes(item?.link)
                              ? item?.icon + "Light"
                              : item?.icon
                          }
                          width="30px"
                          height="30px"
                          color={
                            location.pathname.includes(item?.link)
                              ? "#fff"
                              : "#D0004B"
                          }
                        ></Icon>}
                        <h5>{t(item.title)}</h5>
                      </NavLink>
                    </>
                  )}
                </div>
              ))}
          </>
        ) : (
          <>
            {links &&
              links.map((item, i) => (
                <div
                  className="li-content justify-content-center"
                  style={{ padding: "15px 0px" }}
                >
                  {item?.label === "add_member" ? (
                    <div style={{
                      ...styles.dropdownButton,
                      backgroundColor: "inherit",
                      padding:"0"
                    }}>
                      <button
                        onClick={() => {
                          // active(i);
                          setDropdownCollapseOpen(!dropdownCollapseOpen);
                        }}
                        style={{
                          ...styles.dropdownButton,
                          backgroundColor: "inherit",
                          padding:"0"
                        }}
                      >
                        <Icon
                          iconName={item.icon}
                          width="30px"
                          height="30px"
                          color={item.active ? "#fff" : "#D0004B"}
                        />
                      </button>

                      {dropdownCollapseOpen && (
                          <div style={styles.dropdownMenu && {
                          // top: "10px",
                          // left: "8px",
                          // position: "absolute",
                          // zIndex:"9999"
                        }} className="bg-white">
                          {item?.canAddSingleMember && (
                            <NavLink
                              to={`${"/user" + item.link}`}
                              style={({ isActive }) =>
                                isActive &&
                                !location?.pathname?.includes("/bulk-upload")
                                  ? { ...styles.activeItem , fontSize: "12px", fontFamily:"700", padding: "2px 3px",}
                                  : { ...styles.dropdownItem , fontSize: "12px", fontFamily:"500", padding: "2px 3px",}
                              }
                            >
                              {t("Add")}
                            </NavLink>
                          )}
                          {item?.canBulkUploadData && (
                            <NavLink
                              to={`/user/add-members/bulk-upload`}
                              style={({ isActive }) =>
                                isActive &&
                                location?.pathname?.includes("/bulk-upload")
                                ? { ...styles.activeItem , fontSize: "12px", padding: "2px 3px",}
                                : { ...styles.dropdownItem , fontSize: "12px", padding: "2px 3px",}
                              }
                            >
                              {t("Upload")}
                            </NavLink>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                  <NavLink
                    to={`${"/user" + item.link}`}
                    // onClick={() => active(i)}
                    className={
                      location.pathname.includes(item?.link) 
                      && "activeClassWhite"
                      // item?.label !== "add_member"
                      //   ? "activeClassWhite"
                      //   : null
                    }
                  >
                    <Icon
                      iconName={
                        location.pathname.includes(item?.link)
                          ? item?.icon + "Light"
                          : item?.icon
                      }
                      width="30px"
                      height="30px"
                      color={
                        location.pathname.includes(item?.link)
                          ? "#D0004B"
                          : "#D0004B"
                      }
                    ></Icon>
                  </NavLink>
                  )}
                </div>
              ))}
          </>
        )}
        {(userType === "admin" || userType === "viewer") && (
          <NavLink
            to={`/user/donate`}
          >
            <FundMeButton isCollapsed={open ? false : true}/>
          </NavLink>
        )}
        { userType !== "admin" ? open ? (
          <div
            className="li-content"
            style={{ padding: "20px 35px" }}
            onClick={() => setshow(true)}
          >
            <Link>
              <Icon
                iconName="wlogout"
                color={open ? " #D0004B" : "#D0004B"}
                width="22px"
                height="22px"
              ></Icon>
              <h4 style={{ color: " #D0004B" }}>{t("Logout")}</h4>
            </Link>
          </div>
        ) : (
          <div onClick={() => setshow(true)}>
            <Icon
              cursor="pointer"
              iconName="wlogout"
              width="22px"
              color="#D0004B"
              m="auto"
              mr="45%"
              mt="18%"
              height="22px"
            ></Icon>
          </div>
        ):''}
      </div>
      <div className={open ? "wToggle" : "bToggle"}>
        <Button
          icon
          onClick={handleClick}
          type="blank"
          iconName={open ? "whitetoggle" : "blacktoggle"}
        />
      </div>

      <Modal show={show} onHide={() => setshow(false)} className="logout-modal">
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <button
              type="button"
              class="close"
              aria-label="Close"
              onClick={() => setshow(false)}
            >
              <span aria-hidden="true">
                <Icon iconName="modalClose" />
              </span>
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <Icon iconName="Logout" style={{ margin: "auto" }} />
            <div className="text">{t("Are you sure you want to log out?")}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={() => setshow(false)} className="cancel">
            {t("Cancel")}
          </button>
          <button onClick={() => handleLogOut(true)} className="logout">
            {t("Logout")}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LeftSidebar;
